
import { AggregateBy, PageStat, ActionStat, DailyStat, PlatformStat, BrowserStat, OSStat, TimeStat, LanguageStat, ReferrerStat } from '../types';
import { getDailyStats } from './dailyStats';
import { getPlatformStats } from './platformStats';
import { getBrowserStats } from './browserStats';
import { getOSStats } from './osStats';
import { getTimeStats } from './timeStats';
import { getLanguageStats } from './languageStats';
import { getReferrerStats } from './referrerStats';
import { getGenericStats } from './genericStats';
import { AuthFilter } from '@/components/analytics/AuthFilterButtons';

/**
 * Get aggregated usage statistics for a given time period
 * @param startDate - Start date for the query period
 * @param endDate - End date for the query period
 * @param groupBy - Field to group by (page_path, action_type, etc.)
 * @param authFilter - Filter by authentication status (all, authenticated, unauthenticated)
 */
export const getAggregatedStats = async (
  startDate: Date,
  endDate: Date,
  groupBy: AggregateBy = 'page_path',
  authFilter: AuthFilter = 'all'
): Promise<PageStat[] | ActionStat[] | DailyStat[] | PlatformStat[] | BrowserStat[] | OSStat[] | TimeStat[] | LanguageStat[] | ReferrerStat[]> => {
  try {
    if (groupBy === 'daily') {
      return getDailyStats(startDate, endDate, authFilter);
    } else if (groupBy === 'platform') {
      return getPlatformStats(startDate, endDate, authFilter);
    } else if (groupBy === 'browser') {
      return getBrowserStats(startDate, endDate, authFilter);
    } else if (groupBy === 'os') {
      return getOSStats(startDate, endDate, authFilter);
    } else if (groupBy === 'time') {
      return getTimeStats(startDate, endDate, authFilter);
    } else if (groupBy === 'language') {
      return getLanguageStats(startDate, endDate, authFilter);
    } else if (groupBy === 'referrer') {
      return getReferrerStats(startDate, endDate, authFilter);
    } else {
      return getGenericStats(startDate, endDate, groupBy, authFilter);
    }
  } catch (error) {
    console.error(`Error fetching ${groupBy} stats:`, error);
    throw error;
  }
};
